// Main navigation
const repositionHomepage = true;

jQuery(document).ready(function ($) {
  // Sticky nav
  $(window).scroll(toggleScrollClass);

  // $(window).on('load', () => adjustPageContentPosition(repositionHomepage));
  // $(window).resize(() => adjustPageContentPosition(repositionHomepage));

  /**
   * Toggles the a 'scrolling' class on an element whenever a certain threshold
   * is reached. Typcially added to the body element for use with the navbar.
   */
  function toggleScrollClass() {
    const scrollThreshold = 200;
    const targetElement = 'body';
    const scrollClass = 'scrolling';

    if ($(window).scrollTop() > scrollThreshold) {
      $(targetElement).addClass(scrollClass);
    } else {
      $(targetElement).removeClass(scrollClass);
    }
  }

  /**
   * This sets the page padding-top to accomodate for the fixed navbar
   */
  function adjustPageContentPosition(repositionHomepage) {
    let navBarHeight = $('.off-canvas-content > .header').outerHeight();
    let adminBarHeight = $('#wpadminbar').outerHeight() || 0;

    // Add wpadminbar height if logged into WP
    if ($(document.body).hasClass('admin-bar')) {
      navBarHeight += adminBarHeight;
    }

    if (repositionHomepage) {
      // Reposition content on all pages, including homepage
      $('.off-canvas-content > .content').css('padding-top', navBarHeight);
      $('.off-canvas-content > .simple-site-obit-single').css('padding-top', navBarHeight);
    } else {
      // Reposition all pages that are not the homepage
      $("body:not('.home') .off-canvas-content > .content").css('padding-top', navBarHeight);
      $('.off-canvas-content > .simple-site-obit-single').css('padding-top', navBarHeight);

      const isMobile = $(window).width() < 640;

      // Reposition homepage content if on mobile
      if (isMobile) {
        $("body.home .off-canvas-content > .content").css('padding-top', navBarHeight);
      } else {
        // Still reposition homepage by #wpadminbar height if logged-in
        $("body.home .off-canvas-content > .content").css('padding-top', adminBarHeight);
      }
    }
  }
});
